import * as Notifications from "expo-notifications";
import { router } from "expo-router";
import React from "react";

import Onboarding from "@/components/ui/onboarding";
import { useAuthStore } from "@/stores/use-auth-store";

export default function OnboardingNotifications() {
  const setHasCompletedOnboarding = useAuthStore(
    (state) => state.setHasCompletedOnboarding,
  );

  const handleBack = () => {
    router.back();
  };

  const handleComplete = () => {
    setHasCompletedOnboarding(true);
    router.replace("/(auth)");
  };

  const handleNext = async () => {
    const { status } = await Notifications.requestPermissionsAsync();
    if (status !== "granted") {
      console.log("Notification permission denied");
    }
    handleComplete();
  };

  return (
    <Onboarding
      image={require("@/assets/images/onboarding/notifications.png")}
      title="Stay Informed"
      description="Receive updates about booking status, driver arrival and completed jobs"
      buttonText="Next"
      onButtonPress={handleNext}
      onBackPress={handleBack}
      step={3}
      totalSteps={3}
    />
  );
}
